import { useMutation } from '@tanstack/react-query';
import { Checkbox, Col, Modal, Row, Space, Table, Typography } from 'antd';
import { PaymentSummaryApis } from 'apis/PaymentSummaryApis';
import { SalesInfoApis } from 'apis/SalesInfoApis';
import { Button, ButtonAction } from 'components';
import TableComponent from 'components/Table/TableComponent';
import { ColumnsTypeCustom } from 'interfaces/Table/ColumnType';
import React, { useEffect, useState } from 'react';
import { UnorderedListOutlined } from '@ant-design/icons';
import { BookOutlined } from '@ant-design/icons';
import { PrinterOutlined } from '@ant-design/icons';
import { CopyOutlined } from '@ant-design/icons';
import { EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import formatNumber, {
  generateUUID,
  toastError,
  toastInfo,
} from 'utils/constants/functions';
import { ICreateBILLING, ICreateEInvoice } from 'interfaces/SalesInfo';
import { log } from 'console';

interface IProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  sumPaymentId: any;
  customerId?: string;
  onCheckDebt?: (customerId: string) => void;
  isEligibleToLock?: boolean;
}
const ModalExportHDDT = (props: IProps) => {
  const {
    isOpen,
    setIsOpen,
    sumPaymentId,
    customerId,
    onCheckDebt,
    isEligibleToLock,
  } = props;
  const navigate = useNavigate();
  const [dataOrders, setDataOrders] = useState<any[]>([]);
  const [dataOrderSelected, setDataOrderSelected] = useState<any[]>([]);
  const [isCheckingDebt, setIsCheckingDebt] = useState(false);
  const [pendingBillingParams, setPendingBillingParams] =
    useState<ICreateBILLING | null>(null);

  const { mutate: mutateGetOrderBillPaymentList, isPending: loading } =
    useMutation({
      mutationFn: PaymentSummaryApis.getOrderExportHDDTList,

      onSuccess: (data) => {
        setDataOrders(data?.data?.getOrderBySumPayment?.items ?? []);
        console.log('data', data?.data?.getOrderBySumPayment?.items);
      },
      onError: (error) => {
        console.error(error);
      },
    });

  const {
    mutate: createBillingMutate,
    isPending: isCreateBillingMutatePending,
  } = useMutation({
    mutationFn: (params: ICreateBILLING) => SalesInfoApis.createBilling(params),
    onSuccess: (res: any) => {
      toastInfo('Hệ thống đang tạo Billing!');
      setPendingBillingParams(null);
      handleCancel();
    },
    onError: (error: any) => {
      toastError(`${error?.response.data.message ?? error}`);
      setPendingBillingParams(null);
      handleCancel();
    },
  });

  const {
    mutate: createEInvoiceMutate,
    isPending: isCreateEInvoiceMutatePending,
  } = useMutation({
    mutationFn: (params: ICreateEInvoice) =>
      SalesInfoApis.createEInvoice(params),
    onSuccess: (res: any) => {
      if (res?.OUT_REFNO) {
        toastInfo('Hệ thống đang tạo HĐĐT!');
        handleCancel();
      }
    },
    onError: (error) => {
      toastError(`Lỗi khi tạo hóa đơn điện tử. ${error?.message ?? error}`);
      handleCancel();
    },
  });

  const {
    mutate: printEInvoiceMutate,
    isPending: isPrintEInvoiceMutatePending,
  } = useMutation({
    mutationFn: (orderId: string) => SalesInfoApis.printEInvoice(orderId),
    onSuccess: async (res, variables) => {
      try {
        if ((res?.data ?? []).length <= 0 && !res?.data?.[0]?.Link) {
          toastError('Bảng kê bán hàng chưa có hoá đơn điện tử!');
          return;
        }
        const link = document.createElement('a');
        const url = res?.data?.[0]?.Link;

        link.href = url;
        link.download = `Hoá_đơn_điền_tử_bảng_kê_bán_hàng_${variables}.pdf`;
        link.target = '_blank';
        link.click();
      } catch (error) {
        toastError(`Lỗi khi xuất file pdf. ${error}`);
      }
    },
    onError: (error) => {
      toastError(`Lỗi khi in hoá đơn điện tử. ${error?.message ?? error}`);
    },
  });

  useEffect(() => {
    if (sumPaymentId) {
      mutateGetOrderBillPaymentList(sumPaymentId);
    }
  }, [isOpen, sumPaymentId]);

  // Khi công nợ pass và có pending billing, tự động tạo billing
  useEffect(() => {
    if (isEligibleToLock && pendingBillingParams) {
      createBillingMutate(pendingBillingParams);
    }
  }, [isEligibleToLock, pendingBillingParams]);

  // const handleSelectedOrder = (order: any) => {
  //   const index = dataOrderSelected.findIndex(
  //     (item) => item?.order?.id === order?.order?.id,
  //   );
  //   if (index !== -1) {
  //     const newData = [...dataOrderSelected];
  //     newData.splice(index, 1);
  //     setDataOrderSelected(newData);
  //   } else {
  //     setDataOrderSelected([...dataOrderSelected, order]);
  //   }
  // };

  const handleCancel = () => {
    setIsOpen(false);
  };

  const handleCreateBilling = (billingParams: ICreateBILLING) => {
    // Lưu billing params để sử dụng sau
    setPendingBillingParams(billingParams);

    if (!customerId || !onCheckDebt) {
      // Nếu không có customerId hoặc onCheckDebt, tạo billing trực tiếp
      createBillingMutate(billingParams);
      return;
    }

    // Gọi checkDebt - sẽ show popup
    onCheckDebt(customerId);
  };

  // const handleExport = () => {
  //   // console.log('dataOrderSelected', dataOrderSelected);
  //   if (dataOrderSelected.length > 0) {
  //     dataOrderSelected.forEach((item) => {
  //       try {
  //         const link = document.createElement('a');
  //         const url = item?.einvoiceUrl;

  //         link.href = url;
  //         link.target = '_blank';

  //         document.body.appendChild(link);
  //         link.click();
  //         document.body.removeChild(link);
  //       } catch (error) {
  //         toastError(`Lỗi khi xuất file pdf. ${error}`);
  //         console.log(`Lỗi khi xuất file pdf. ${error}`);
  //       }
  //     });
  //   }
  // };

  const columns: ColumnsTypeCustom = [
    {
      title: 'Bảng kê',
      width: 150,
      dataIndex: 'orderId',
    },
    {
      title: 'SO',
      width: 150,
      dataIndex: 'soId',
    },
    {
      title: 'Trạng thái đơn',
      // width: 100,
      dataIndex: 'status',
    },
    {
      title: 'Thông báo lỗi',
      // width: 100,
      dataIndex: 'errorMessage',
    },
    {
      title: 'DO',
      width: 150,
      dataIndex: 'doId',
    },
    {
      title: 'GI',
      width: 150,
      dataIndex: 'giId',
    },
    {
      title: 'BILLING',
      width: 185,
      dataIndex: 'billingId',
    },
    {
      title: 'Einvoice',
      dataIndex: 'envoiceId',
      align: 'right',
    },
    {
      title: 'Link',
      dataIndex: 'link',
      render: (link: string) => (
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#1677ff' }}
        >
          {link}
        </a>
      ),
    },
    {
      title: 'Actions',
      fixed: 'right',
      align: 'center',
      render: (__, record: any) => (
        <Space size={'middle'} className="text-lg ">
          <ButtonAction
            tooltip="Tạo Billing"
            disabled={
              !(record?.billingId == null || record?.billingId == '') ||
              isCheckingDebt ||
              !record?.giId ||
              record?.giId === ''
            }
            onClick={() =>
              handleCreateBilling({
                Key: record?.orderId,
                Delivery: record?.doId,
                GoodIssue: record?.giId,
                Year: record?.year.toString(),
              })
            }
          >
            <span className="billing-icon-wrapper">
              <UnorderedListOutlined
                className="billing-icon"
                style={{
                  color:
                    record?.billingId == null || record?.billingId == ''
                      ? record?.giId && record?.giId !== ''
                        ? '#91caff'
                        : '#bfbfbf'
                      : '#bfbfbf',
                  transition: 'color 0.3s',
                }}
              />
            </span>
          </ButtonAction>
          <ButtonAction
            tooltip="Tạo Einvoice"
            disabled={
              !(
                record?.billingId !== null &&
                record?.billingId !== '' &&
                (record?.envoiceId == null || record?.envoiceId == '')
              )
            }
            onClick={() =>
              createEInvoiceMutate({
                orderId: record?.orderId,
                PVBELN: record?.billingId,
              })
            }
          >
            <BookOutlined
              style={{
                color:
                  record?.billingId !== null &&
                  record?.billingId !== '' &&
                  (record?.envoiceId == null || record?.envoiceId == '')
                    ? '#1890ff'
                    : '#bfbfbf',
              }}
            />
          </ButtonAction>
          <ButtonAction
            tooltip="In Einvoice"
            disabled={record?.link == null || record?.link === ''}
            onClick={() => printEInvoiceMutate(record?.orderId)}
          >
            <PrinterOutlined
              style={{
                color: !(record?.link == null || record?.link === '')
                  ? '#1890ff'
                  : '#bfbfbf',
              }}
            />
          </ButtonAction>
          <ButtonAction
            tooltip="Copy Einvoice"
            disabled={record?.link == null || record?.link === ''}
            onClick={() => navigator.clipboard.writeText(record?.link ?? '')}
          >
            <CopyOutlined
              style={{
                color: !(record?.link == null || record?.link === '')
                  ? '#1890ff'
                  : '#bfbfbf',
              }}
            />
          </ButtonAction>
          <ButtonAction
            tooltip="Xem chi tiết bảng kê"
            onClick={() => {
              window.open(
                `/sales-invoice-detail?orderId=${record?.orderId}&orderTypeId=${record.orderTypeId}`,
                '_blank',
              );
            }}
          >
            <EyeOutlined style={{ color: '#1890ff' }} />
          </ButtonAction>
        </Space>
      ),
    },
  ];

  return (
    <Modal
      title="Xuất hóa đơn điện tử"
      footer={null}
      open={isOpen}
      onCancel={handleCancel}
      width={1200}
    >
      <style>
        {`
          .billing-icon-wrapper:hover .billing-icon {
            color: #1890ff !important;
          }
          button:disabled .billing-icon-wrapper:hover .billing-icon {
            color: #bfbfbf !important;
          }
        `}
      </style>
      {/* <Space
        direction="vertical"
        className="w-full !max-h-[70vh] overflow-auto"
      >
        {dataOrders?.length > 0 ? (
          dataOrders.map((item, index) => {
            return (
              <Checkbox
                key={item?.order?.id}
                disabled={!item?.einvoiceUrl}
                onChange={() => handleSelectedOrder(item)}
              >
                {item?.order?.id}
              </Checkbox>
            );
          })
        ) : (
          <Typography.Text>Không có bảng kê</Typography.Text>
        )}
      </Space> */}
      <TableComponent
        scroll={{ x: 'max-content' }}
        columns={columns}
        dataSource={dataOrders}
        rowKey={(record: any) => record?.id || generateUUID()}
        loading={
          loading ||
          isCreateEInvoiceMutatePending ||
          isCreateBillingMutatePending ||
          isPrintEInvoiceMutatePending
        }
        pagination={false}
      />
    </Modal>
  );
};

export default ModalExportHDDT;
